import React from "react";
import coon from "../../Assets/Csoon.png";

import branding from "../../Assets/branding.jpg";
import ContentCreation from "../../Assets/ContentCreation.jpg";

import Email from "../../Assets/Email.jpg";

import social_media from "../../Assets/social-media.jpg";

import Virtual_Services from "../../Assets/Virtual-Services.jpg";

import web_design from "../../Assets/web-design.jpg";

import seo from "../../Assets/seo.jpg";
const sectionData = [
  {
    title: "Branding Package [USD 850]",
    description:
      "Transform your brand identity into a powerful visual story that resonates with your audience. We combine creativity with strategy to ensure your brand experience leaves a lasting impact.",
    image: branding,
    checklistItems: [
      "Bio Makeover & Organisation",
      "Primary & Alternative Logo Designs",
      "Custom Colour Palette & Typography Suite",
      "Letter head & Business Card Designs",
      "In-Depth Brand Strategy & Guidelines",
      "Instagram Aesthetic Overhaul",
    ],
  },
  {
    title: "Signature Content Creation [USD 550]",
    description:
      "Elevate your social media presence with an entire month's worth of expertly crafted content. We curate posts and stories that authentically reflect your brand and engage your audience.",
    image: ContentCreation,
    checklistItems: [
      "24 custom-designed posts & 24 stories for Instagram & Facebook",
      "Captivating captions with tailored hashtag research for organic reach",
      "Feed planning & story alignment",
      "Daily one-hour organic engagement",
      "Scheduled posts & stories",
    ],
  },
  {
    title: "Full Social Media Management - Growth Package [USD 800]",
    description:
      "Take the hassle out of social media. We manage every aspect of your brand's online presence, from content creation to performance analytics, allowing you to focus on what you do best.",
    image: social_media,
    checklistItems: [
      "24 custom-designed posts & 24 stories for Instagram & Facebook",
      "Bio optimization & personalized content strategy",
      "Engaging captions with hashtag research",
      "One hour of daily organic engagement",
      "Analytics and performance reports",
      "Scheduled posts & stories",
      "Highlight covers for Instagram",
      "12 Reels + Reel covers",
    ],
  },
  {
    title: "Email Marketing [USD 850]",
    description:
      "Maximize your reach with targeted email marketing strategies. We craft compelling email campaigns that resonate with your audience and drive real results for your business.",
    image: Email,
    checklistItems: [
      "Tailored Email Strategy",
      "8 Engaging Emails Per Month",
      "List Building & Email Automation",
      "Detailed Performance Tracking & Reporting",
    ],
  },
  {
    title: "Virtual Assistant Services [USD 800]",
    description:
      "Let us help with administrative tasks, content scheduling, email marketing, and more. With 2 hours of dedicated support each day, we provide the flexibility you need to focus on what matters most.",
    image: Virtual_Services,
    checklistItems: [
      "Streamlined administrative support",
      "Research & data analysis to support decision-making",
      "Content scheduling and creation assistance",
      "Client communication & email marketing",
      "Task delegation for smoother operations",
    ],
  },
  {
    title: "Web Design Services [Starting From USD 1000]",
    description:
      "Create an online presence that captivates and converts with a custom website designed to highlight your brand’s personality. We use the Showit platform to create stunning, mobile optimized websites that make a lasting impression.",
    image: web_design,
    checklistItems: [
      "Fully Customized Design, 5 main pages & Basic SEO",
      "Brand-Specific Imagery + Visual Storytelling",
      "Integration of Third Party Services e.g., Calendly, Flodesk",
      "Mobile & Desktop Optimization",
      "Wireframe Mockups & Site Structure",
      "Web Launch Support + Google Console Integration",
    ],
  },
  {
    title: "SEO Services [Starting From USD \u00241000]",
    description:
      "Increase your website’s visibility and drive organic traffic with our tailored SEO packages. We focus on strategic keyword research, on-site optimization, and content refinement to ensure long-term growth.",
    image: seo,
    checklistItems: [
      "SEO Basic Package (35 Targeted Keywords - $1100)",
      "SEO Standard Package (50 Targeted Keywords - $2000)",
      "SEO Advanced Package (100 Targeted Keywords - $3000)",
    ],
  },
];

const Section3 = ({ data, imageOnRight, index }) => {
  const ContentSection = () => (
    <div className="w-full md:w-1/2 space-y-8 px-4 md:px-0 mb-8 md:mb-0">
      <h2
        className="text-2xl md:text-3xl font-semibold text-gray-800"
        style={{ fontFamily: "Blacker Pro Display" }}
      >
        {data.title}
      </h2>
      <div className="max-w-md">
        <p
          className="text-gray-700 leading-relaxed"
          style={{ fontFamily: "commuterssans-semibold" }}
        >
          {data.description}
        </p>
      </div>
      <button
        className="w-full md:w-auto px-6 py-2 border border-gray-300 text-sm text-gray-800 hover:bg-[#704735] hover:text-white transition-colors font-semibold tracking-widest"
        style={{ fontFamily: "Blacker Pro Display" }}
      >
        LET'S CHAT
      </button>
    </div>
  );

  return (
    <div className="container mx-auto px-4 md:px-36 py-8 md:py-16 max-w-6xl">
      <div className="flex flex-col md:flex-row items-start justify-between">
        {imageOnRight ? (
          <>
            <ContentSection />
            <div className="w-full md:w-1/2 flex justify-center items-start">
              <div className="w-full md:w-96 h-64 md:h-96">
                <img
                  src={data.image}
                  alt="Service visual"
                  className="w-full h-full object-fit shadow-xl"
                />
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="w-full md:w-1/2 flex justify-center items-start mb-8 md:mb-0">
              <div className="w-full md:w-96 h-64 md:h-96">
                <img
                  src={data.image}
                  alt="Service visual"
                  className="w-full h-full object-cover shadow-xl"
                />
              </div>
            </div>
            <ContentSection />
          </>
        )}
      </div>

      <div className="pt-8 md:pt-16 px-4 md:px-0">
        <h3
          className="text-gray-700 uppercase text-lg mb-6 font-semibold"
          style={{ fontFamily: "Blacker Pro Display" }}
        >
          HERE'S WHAT WE OFFER:
        </h3>

        <div className="space-y-4 ">
          {data.checklistItems.map((text, idx) => (
            <div
              key={idx}
              className="flex items-center gap-3 border-b border-gray-200 pb-3"
            >
              <svg
                className="w-6 h-6 text-gray-600 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="3"
                  d="M5 13l4 4L19 7"
                ></path>
              </svg>
              <span
                className="text-gray-700 text-lg font-semibold"
                style={{ fontFamily: "Lato-Regular" }}
              >
                {text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const AlternatingSections = () => {
  return (
    <>
      {sectionData.map((data, index) => (
        <Section3
          key={index}
          data={data}
          imageOnRight={index % 2 === 0}
          index={index}
        />
      ))}
    </>
  );
};

export default AlternatingSections;
